import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import TypeInvestigationService from "../../../services/TypeInvestigationService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function TypeInvestigationModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  typeInvestigationTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);

  useEffect(() => {
    if (typeInvestigationTarget) {
      setformField([{ name: ["name"], value: typeInvestigationTarget.name }]);
    }
  }, [typeInvestigationTarget]);

  const onFinish = (values) => {
    let typeInvestigationR = { ...values };
    if (typeInvestigationTarget) {
      typeInvestigationR.id = typeInvestigationTarget.id;
      TypeInvestigationService.updateTypeInvestigation(typeInvestigationR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Tipo de investigación actualizada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar el Tipo de investigación. " +
                res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
      TypeInvestigationService.createTypeInvestigation(typeInvestigationR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Tipo de investigación registrada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar el Tipo de investigación. " +
                res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };
  return (
    <Modal
      title="Registrar Tipo de investigación"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre del Tipo de investigación"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre del Tipo de investigación.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
